var React = require('react');

function IconItemCheaper (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"height":"32","rx":"7","transform":"matrix(.70710678 -.70710678 .70710678 .70710678 -36.17 58.75)","width":"50","x":"27.84","y":"57.03","key":0}),React.createElement("circle",{"cx":"63.01","cy":"62.86","r":"5.29","key":1}),React.createElement("path",{"d":"m63 62.86s12.28-15.33 24-26.11 13.25-7.7 13.91-6.69c4.16 6.36-29.17 18.7-37.91 32.8z","key":2})]);
}

IconItemCheaper.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = IconItemCheaper;

IconItemCheaper.default = IconItemCheaper;
